import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import DropdownPopper from 'components/molecules/Poppers/DropdownPopper/DropdownPopper';

const StyledEditorLinkPopup = styled(DropdownPopper)`
  .EditorLinkPopup {
    &-form {
      .Form-fields {
        gap: ${props => props.theme.layout('1sp')};
      }
    }
    
    &-buttons {
      display: flex;
      justify-content: flex-end;
      gap: ${props => props.theme.layout('0.75sp')};
      margin-top: ${props => props.theme.spacing(2)};
    }  
  }
  
  ${ComponentStyles}
`;

StyledEditorLinkPopup.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorLinkPopup;
